import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ConverterService, Facet, OccEndpointsService } from '@spartacus/core'
import { Observable } from 'rxjs'
import { map, pluck } from 'rxjs/operators'
import { MbHomepageFacetsAdapter } from '../connectors/mb-homepage-facets/mb-homepage-facets.adapter'
import { MB_HOMEPAGE_FACETS_NORMALIZER } from '../connectors/mb-homepage-facets/mb-convertors'
import { MbConstants } from '../../shared/mb-constants'

@Injectable({
  providedIn: 'root'
})
export class MbOccHomepageFacetsAdapter implements MbHomepageFacetsAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService) {
  }

  constants = MbConstants

  load (): Observable<Facet[]> {
    return this.http
      .get(this.getEndpoint())
      .pipe(
        pluck('facets'),
        map((facets: any) => (facets as Facet[])?.filter((facet: Facet) =>
            [this.constants.CATEGORY_FACET_CODE.toLowerCase(),
              this.constants.CATEGORY_OR_FACET_CODE.toLowerCase(),
              this.constants.ALL_CATEGORIES.toLowerCase(),
              this.constants.ALL_CATEGORIES_OR.toLowerCase(),
              this.constants.CODE_STRING.toLowerCase()
            ].findIndex((code: string) => code === facet.name?.toLowerCase()) < 0)),
        this.converter.pipeable(MB_HOMEPAGE_FACETS_NORMALIZER)
      )
  }

  protected getEndpoint (): string {
    return this.occEndpoints.buildUrl('homepageFacets')
  }
}
